import React from 'react'
import { Row, Col, Card,} from 'antd';
import Foot from '../cpn/Foot';
import RegisterForm from './RegisterForm';
import Top from '../cpn/Top';
import { useNavigate } from 'react-router-dom';
function Regist() { 
    const navi = useNavigate()
    return (
        <>
            <Top/>
            <Row style={{padding:'50px 0',backgroundColor:"#eee",}}>
                <Col span={5}></Col>
                <Col span={6}>
                    <Card
                        title='方式一、由客户经理注册，帮助做软件的系统设置'
                        
                    >
                        <p>第一步：<a href='/download/table.xlsx'>下载系统设置表</a>并填写</p>
                        <p>第二步：添加客户经理微信，把表格发给客户经理</p>
                        <p>
                            <img alt='' src='./img/jack.png' width={400}/>
                        </p>
                    </Card>
                </Col>
                <Col span={1}></Col>
                <Col span={6} >
                    <Card
                        title='方式二、在线注册，自行做软件的系统设置'
                        style={{minHeight:'600px'}}
                    >
                        <p>本方式适合动手能力比较强的用户</p>
                        <p>如有不懂的地方，可以查看<a onClick={() => {navi('/')}}>首页</a>的免费试用教程</p>
                        <p>提交后耐心等待1-2秒，注册成功后<a onClick={() => {navi('/Login')}}>登录系统</a>。</p>
                        <p>如需帮助，添加左边客户经理微信</p>
                        <RegisterForm />
                    </Card>
                </Col>
                <Col span={4}></Col>
            </Row>
            <Foot />
        </>
    )
}

export default Regist